export default {
		getCurrentTime: function() {
      var today = new Date();
      var h = today.getHours();
      var m = today.getMinutes();
      h = (h < 10 ? '0'+h : h); 
      m = (m < 10 ? '0'+m : m); 
      return h+':'+m;
    }
}  